/* tslint:disable */
/* eslint-disable */
export enum TypeEnum {
  NotSet = 0,
  Standard = 1,
  Impact = 2,
  Plugg = 3
}
